import { delay } from "redux-saga/effects";
import makeRequest from "./makeRequest";

const MAX_ATTEMPTS = 3;
const BASE_MS = 500;

const isRetriable = (result) => {
  const status = result?.error?.status;
  if (typeof status !== "number") return true;
  return status >= 500 || status === 408 || status === 429;
};

export function* postWithRetry(url, params, options) {
  let lastResult;
  for (let i = 0; i < MAX_ATTEMPTS; i++) {
    lastResult = yield* makeRequest.post(url, params, options);
    if (lastResult.success) return lastResult;
    if (i === MAX_ATTEMPTS - 1 || !isRetriable(lastResult)) return lastResult;
    yield delay(BASE_MS * 2 ** i + Math.floor(Math.random() * 100));
  }
  return lastResult;
}

export default postWithRetry;
